import React, { useEffect, useState } from "react";
import { ShieldCheck, Users, Gamepad2, Play, Rocket } from "lucide-react";
import api from "@/lib/api";

const fmt = (n) => (n >= 1000 ? `${(n / 1000).toFixed(n >= 10000 ? 0 : 1)}k` : `${n}`);

// §15/§17 — live launch trust badges for the marketing pages.
export default function LaunchTrustBadges({ className = "" }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/launch-stats").then((r) => setD(r.data)).catch(() => setD(false)); }, []);
  if (!d) return null;

  const tiles = [
    { icon: Users, label: "creators building", value: fmt(d.creators) },
    { icon: Gamepad2, label: "games created", value: fmt(d.games) },
    { icon: Play, label: "games played", value: fmt(d.plays) },
    { icon: ShieldCheck, label: "certified original", value: "100%" },
  ];

  return (
    <div className={`max-w-4xl mx-auto ${className}`} data-testid="launch-trust-badges">
      {d.phase === "founding" && (
        <div className="flex justify-center mb-5">
          <div data-testid="launch-phase-badge"
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-gradient-to-r from-[#7c3aed]/25 to-[#3b9eff]/25 border border-[#3b9eff]/40 text-sm font-semibold text-white">
            <Rocket className="w-4 h-4 text-[#8fc6ff]" />
            Founding phase — <b className="text-white">{d.founding_spots_left}</b> of {d.founding_cap} founding spots left
          </div>
        </div>
      )}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {tiles.map((t) => (
          <div key={t.label} data-testid={`launch-stat-${t.label.split(" ")[0].toLowerCase()}`}
            className="rounded-2xl border border-white/10 bg-white/[0.04] p-4 text-center">
            <t.icon className="w-5 h-5 mx-auto mb-2 text-[#3b9eff]" />
            <div className="font-display text-2xl font-extrabold text-white tabular-nums">{t.value}</div>
            <div className="text-[11px] text-white/50 mt-0.5">{t.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
